var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"iq-answer-snapshot-meta"},[_c('span',{staticClass:"iq-answer-snapshot-meta__date"},[_vm._v("As of "+_vm._s(_vm.asOf))]),_c('button',{staticClass:"iq-answer-snapshot-meta__refresh",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('refresh')}}},[_vm._v(" Refresh ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }